export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const LIKEPOST = 'LIKEPOST';
export const FETCH_ALL = 'FETCH_ALL';
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';

//insure data load fast, more scaleable
// much less error points